import React, {FC, ReactNode, useState} from 'react';

import {getIsAppTicketingEnabled} from '../../../../../../../libs/inboxes/business/src/cells/ticketing';
import {getWaitingTicketStatuses} from '../../../../../../../libs/inboxes/store/src/ticketing/ticketStatusSelectors';
import {onlyItem} from '../../../../../../../libs/shared/core/src/helpers/utilities/arrayHelpers';
import {TicketStatusModel} from '../../../../../../../libs/shared/core/src/models/api/ticketStatusModel';
import {DropdownInheritableProps} from '../../../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {useAppSelector} from '../../../../../../helpers/appReduxHelpers';
import {SnoozeTicketStatusDropdown} from './snoozeTicketStatusDropdown';

/*
 * Props.
 */

interface SnoozeTicketStatusDropdownContainerProps extends DropdownInheritableProps {
  title: ReactNode;
  computeIsTicketStatusDisabled?: (ticketStatus: TicketStatusModel) => boolean;
  renderSnoozeDropdown: (ticketStatus: TicketStatusModel, onBackClick: (() => void) | undefined) => ReactNode;
  onBackClick?: () => void;
  backLabel?: ReactNode;
}

/*
 * Component.
 */

export const SnoozeTicketStatusDropdownContainer: FC<SnoozeTicketStatusDropdownContainerProps> = (props) => {
  const isTicketingEnabled = useAppSelector(getIsAppTicketingEnabled);
  const waitingTicketStatuses = useAppSelector(getWaitingTicketStatuses);

  const {renderSnoozeDropdown, ...dropdownProps} = props;
  const [ticketStatus, setTicketStatus] = useState<TicketStatusModel | undefined>(
    waitingTicketStatuses && onlyItem(waitingTicketStatuses),
  );

  // This dropdown should only be rendered when ticketing is provisioned.
  // TODO: Render an error state, just in case.
  if (!isTicketingEnabled || !waitingTicketStatuses) {
    return null;
  }

  // Once a ticket status has been chosen, render the regular snooze dropdown.
  if (ticketStatus) {
    const onBackClick =
      waitingTicketStatuses && waitingTicketStatuses.length > 1
        ? () => setTicketStatus(undefined)
        : undefined;

    return renderSnoozeDropdown(ticketStatus, onBackClick);
  }

  // Render the dropdown to pick a ticket status for the snooze.
  return (
    <SnoozeTicketStatusDropdown
      {...dropdownProps}
      ticketStatuses={waitingTicketStatuses}
      onTicketStatusSelect={(_event, newTicketStatus) => setTicketStatus(newTicketStatus)}
      onBackClick={props.onBackClick}
      backLabel={props.backLabel}
    />
  );
};
